import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DirectoryAPIActions } from './directory.actions';
import { DirectoryService } from './api/directory.service';

@Injectable()
export class DirectoryEffects {
  private readonly actions$ = inject(Actions);
  private readonly directoryService = inject(DirectoryService);

  loadSections$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DirectoryAPIActions.loadSections),
      mergeMap(action =>
        this.directoryService.fetchDataFromApi(action.apiUrl).pipe(
          map(sections =>
            DirectoryAPIActions.sectionsLoadedSuccess({ sections })
          ),
          catchError(error =>
            of(
              DirectoryAPIActions.sectionsLoadedFail({ message: error.message })
            )
          )
        )
      )
    )
  );
}
